import { useState } from "react";
import ReactMarkdown from "react-markdown";

const mdStyles = "text-[14px] text-[#37352F] leading-relaxed prose prose-sm max-w-none prose-p:my-1 prose-ul:my-1 prose-ol:my-1 prose-li:my-0.5 prose-headings:my-2 prose-headings:text-[#37352F] prose-code:text-[13px] prose-code:bg-[#F1F1EF] prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-a:text-[#2383E2] prose-a:no-underline hover:prose-a:underline prose-blockquote:border-l-[#E0E0DE] prose-blockquote:text-[#6B6B6B] prose-hr:border-[#E0E0DE]";

function LinkRenderer({ href, children }) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className="text-[#2383E2] hover:underline">{children}</a>;
}

export function MarkdownRender({ content }) {
  return (
    <div className={mdStyles}>
      <ReactMarkdown components={{ a: LinkRenderer }}>{content}</ReactMarkdown>
    </div>
  );
}

export function MarkdownEditor({ value, onChange, onSubmit, placeholder = "Write a note... (supports **markdown**)" }) {
  const [tab, setTab] = useState("write");

  return (
    <div className="border border-[#E0E0DE] rounded-[6px] overflow-hidden">
      <div className="flex border-b border-[#E0E0DE] bg-[#F7F6F3]">
        <button onClick={() => setTab("write")} className={"px-3 py-1.5 text-[12px] font-medium transition-colors " + (tab === "write" ? "text-[#37352F] border-b-2 border-[#37352F] bg-white -mb-px" : "text-[#6B6B6B] hover:text-[#37352F]")}>Write</button>
        <button onClick={() => setTab("preview")} className={"px-3 py-1.5 text-[12px] font-medium transition-colors " + (tab === "preview" ? "text-[#37352F] border-b-2 border-[#37352F] bg-white -mb-px" : "text-[#6B6B6B] hover:text-[#37352F]")}>Preview</button>
      </div>
      {tab === "write" ? (
        <textarea value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
          className="w-full text-[14px] bg-white border-none outline-none resize-none p-3 text-[#37352F] placeholder:text-[#A3A3A0] min-h-[80px] font-mono" rows={3} />
      ) : (
        <div className="p-3 min-h-[80px] bg-white">
          {value.trim() ? <MarkdownRender content={value} /> : <p className="text-[14px] text-[#A3A3A0] italic">Nothing to preview</p>}
        </div>
      )}
      {value.trim() && onSubmit && (
        <div className="flex justify-end px-3 py-2 border-t border-[#E0E0DE] bg-[#F7F6F3]">
          <button onClick={onSubmit} className="text-[13px] font-medium text-[#2383E2] hover:text-[#1B6EC2]">Add note</button>
        </div>
      )}
    </div>
  );
}
